import { render, staticRenderFns } from "./BusinessesList.vue?vue&type=template&id=61bb5ddb&scoped=true&"
import script from "./BusinessesList.vue?vue&type=script&lang=js&"
export * from "./BusinessesList.vue?vue&type=script&lang=js&"
import style0 from "./BusinessesList.vue?vue&type=style&index=0&id=61bb5ddb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bb5ddb",
  null
  
)

export default component.exports